module.exports = __webpack_public_path__ + "img/flower-top.488bb066.png";